import Vue from 'vue';
import Router from 'vue-router';

import order from './order'
import drainage from './drainage'
import year from './year'
import special from './special'
Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: '/mitu',
    routes: [
        ...order,
        ...drainage,
        ...year,
        ...special
    ]
});

export default router;


// WEBPACK FOOTER //
// ./src/router/mitu/index.js